import React from 'react';
import PropTypes from 'prop-types';
// componentes
import { Header, Logo, Grid } from '@design-system-coopeuch/web';
import Loader from '../../molecules/Loader/Loader';

// context
import { StepperProvider } from '../../molecules/Stepper/StepperContext';
import { LoaderProvider } from '../../molecules/Loader/LoaderContext';

// assets
import { StyledWrapperHeader, StyleLayout } from './styles';
/* istanbul ignore next */
const Layout = ({ children }) => {

  /* istanbul ignore next */
  return (
    <LoaderProvider>
      <Loader />
      <div className="bg-primary">
        <StyledWrapperHeader className="container">
          <Header logo={<Logo />}>{ }</Header>
        </StyledWrapperHeader>
      </div>

      <StyleLayout>

        <div className="mb-2">
          <div className="container">
            <Grid row>
              <Grid col>
                <h4 className="pt-5 pb-2 text-color-black-85">Hazte Socio Coopeuch</h4>
                <p className="font-size-16 mb-2 text-color-black-85">
                  Completa los siguientes pasos para realizar tu contratación.
                </p>
              </Grid>
            </Grid>
          </div>
        </div>
        <StepperProvider>
          <main className="container mb-3 mb-md-4 bg-amber-100">
            <section>{children}</section>
          </main>
        </StepperProvider>
      </StyleLayout>

    </LoaderProvider>
  )
};

Layout.propTypes = {
  children: PropTypes.node,
};

Layout.defaultProps = {
  children: null,
};

export default Layout;
